module.exports = __webpack_public_path__ + "assets/019929083d4f1b9d458c19f207ab5618.mp3";